/*global */


/**
 * Extension to enable/disable product following pool characteristics
 */
var extension = {} ;
extension.name = "products-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country", "volume-field"] ;



extension.init = function(){
    var view = this ;
    var rootView = view.getRootView() ;
    function getField(code){
        var el = rootView.viewRootEl.querySelector('[data-field-def="pool.'+code+'"]');
        if(!el){
            el = rootView.viewRootEl.querySelector('[data-field-def="spa.'+code+'"]');
        }
        if(!el){
            el = rootView.viewRootEl.querySelector('[data-field-def="diag.'+code+'"]');
        }
        return el;
    }
    rootView.on("render", function(){
        rootView.ensureDisplayed(function(){
            var filterEl = getField('p_filter');
            var poolCoverEl = getField('p_pool_cover');
            var extraInstallationEl = getField('p_extra_installation');
            var volumeEl = getField('p_volume');
            var disinfEl = getField('p_disinfectant');
            var disinfSpaEl = getField('s_disinfectant');
            var flocculationEl = getField('p_flocculation');
            var filterMaintenanceEl = getField('p_filter_maintenance');
            var algaeEl = getField('p_algae');
            var cleaningEl = getField('p_cleaning');
            var disinfShockEl = getField('p_disinf_shock');
            var disinfLongEl = getField('p_disinf_long');
            var volumeSpaEl = getField('s_volume');
            var disinfShockSpaEl = getField('s_disinf_shock');
            var disinfLongSpaEl = getField('s_disinf_long');
            var regulationEl = getField('p_regulation');
            var regulationSpaEl = getField('s_regulation');
    
            
            rootView.productFiltering = function(){
                var filter = filterEl?filterEl.getValue():"" ;
                var poolCover = poolCoverEl?poolCoverEl.getValue():"" ;
                var extraInstallation = extraInstallationEl?extraInstallationEl.getValue():"" ;
                var volume = volumeEl?volumeEl.getValue():0 ;
                var volumeSpa = volumeSpaEl?volumeSpaEl.getValue():0 ;
                var disinf = disinfEl?disinfEl.getValue():"" ;
                var disinfSpa = disinfSpaEl?disinfSpaEl.getValue():"" ;
                
            
                if(disinfEl && regulationEl){
                    regulationEl.setValueEnable("AUTOMATIC_CLPH", (!disinf || disinf === "CHLORINE")) ;
                }
                if(disinfSpaEl && regulationSpaEl){
                    regulationSpaEl.setValueEnable("AUTOMATIC_CLPH", (!disinfSpa || disinfSpa === "CHLORINE")) ;
                }

                if(disinfShockSpaEl){
                    disinfShockSpaEl.setValueEnable("DISINF_PLUS", (volumeSpa >= 0.21 && volumeSpa <= 4.9)) ;
                }
                if(disinfLongSpaEl){
                    disinfLongSpaEl.setValueEnable("BROME_SPATIME", (volumeSpa >= 0.21 && volumeSpa <= 10.2)) ;
                }
                
                if(disinfLongEl){
                    disinfLongEl.setValueEnable("CHLORILONG", (volume >= 15 && volume <= 210)) ;
                    disinfLongEl.setValueEnable("CHLORYTE_STICKS", (volume >= 15 && volume <= 120)) ;
                    disinfLongEl.setValueEnable("CHLORILONG_5F", (volume >= 15 && volume <= 210 &&
                                                ["SAND", "GLASS", "CARTRIDGE", "POCKET"].indexOf(filter)!==-1)) ;
                    disinfLongEl.setValueEnable("CHLORE_5F", (volume >= 0.6 && volume < 15 &&
                                                ["SAND", "GLASS", "CARTRIDGE", "POCKET"].indexOf(filter)!==-1)) ;
                    disinfLongEl.setValueEnable("VARITAB", (volume >= 20 && volume <= 210 &&
                                                ["SAND", "GLASS"].indexOf(filter)!==-1)) ;
                    disinfLongEl.setValueEnable("CHLORILONG_BLOC", (volume >= 20 && volume <= 210)) ;
                    disinfLongEl.setValueEnable("MULTIBLOC", (volume >= 25 && volume <= 210 &&
                                                ["SAND", "GLASS", "CARTRIDGE", "POCKET"].indexOf(filter)!==-1)) ;
                    disinfLongEl.setValueEnable("MULTILONG", (volume >= 30 && volume <= 200 &&
                                                ["SAND", "GLASS"].indexOf(filter)!==-1)) ;
                    disinfLongEl.setValueEnable("CHLORILIQUE_C", true) ;
                    disinfLongEl.setValueEnable("C_AND_E", (volume >= 11 && volume <= 100 &&
                                                ["SAND", "GLASS", "CARTRIDGE", "POCKET"].indexOf(filter)!==-1)) ;
                    disinfLongEl.setValueEnable("S_AND_E_20", (volume >= 11 && volume <= 100 &&
                                                ["SAND", "GLASS", "CARTRIDGE", "POCKET"].indexOf(filter)!==-1)) ;
                    disinfLongEl.setValueEnable("S_AND_E_30", (volume >= 21 && volume <= 120 &&
                                                ["SAND", "GLASS", "CARTRIDGE", "POCKET"].indexOf(filter)!==-1)) ;
                }

                var disinfLong = disinfLongEl?disinfLongEl.getValue():[] ;

                if(disinfLong && disinfShockEl){
                    disinfShockEl.setValueEnable("BAYROSHOCK_LIGHT", 
                        disinfLong.length === 0 || disinfLong.indexOf("BAYROSOFT_LIGHT") !== -1) ;
                    disinfShockEl.setValueEnable("CHLORIKLAR", 
                        disinfLong.length !== 1 || disinfLong.indexOf("BAYROSOFT_LIGHT") === -1) ;
                    disinfShockEl.setValueEnable("CHLORIFIX", 
                        disinfLong.length !== 1 || disinfLong.indexOf("BAYROSOFT_LIGHT") === -1) ;
                    disinfShockEl.setValueEnable("CHLORYTE", 
                        disinfLong.length !== 1 || disinfLong.indexOf("BAYROSOFT_LIGHT") === -1) ;
                }


            
                if(flocculationEl){
                    flocculationEl.setValueEnable("SUPERFLOCK_PLUS", (
                                                volume >= 1 && volume <= 200 &&
                                                ["SAND", "GLASS", ""].indexOf(filter||"")!==-1)) ;
                
                    flocculationEl.setValueEnable("QUICKFLOCK_SUPER", (
                                                ["SAND", "GLASS", ""].indexOf(filter||"")!==-1)) ;
                
                    flocculationEl.setValueEnable("SUPERKLAR", (
                                                ["SAND", "GLASS", "CARTRIDGE", "POCKET", ""].indexOf(filter||"")!==-1)) ;
                
                    flocculationEl.setValueEnable("QUICKFLOCK_AUTO_PLUS", (
                                                ["SAND", "GLASS", ""].indexOf(filter||"")!==-1)) ;
                }
            
                if(filterMaintenanceEl){
                    filterMaintenanceEl.setValueEnable("FILTERCLEAN_TAB", (volume >= 8 && volume <= 150 &&
                                                ["SAND", "GLASS"].indexOf(filter)!==-1)) ;
                }
            
                if(algaeEl){
                    algaeEl.setValueEnable("X100", (
                                                ["TILES", ""].indexOf(poolCover||"")!==-1)) ;
                    algaeEl.setValueEnable("DESALGINE", (
                                                extraInstallation === null ||
                                                extraInstallation.length === 0)) ;
                }
                if(cleaningEl){
                    cleaningEl.setValueEnable("BORDNET", (poolCover !== "SILI_MARBLE")) ;
                    cleaningEl.setValueEnable("BORDNET_GEL_S", (poolCover !== "SILI_MARBLE")) ;
                    cleaningEl.setValueEnable("ADISAN", (poolCover !== "SILI_MARBLE")) ;
                    cleaningEl.setValueEnable("DECALCIT_SUPER", (poolCover !== "SILI_MARBLE")) ;
                }
            };
    
            [filterEl, volumeEl, volumeSpaEl, poolCoverEl, extraInstallationEl, disinfLongEl].forEach(function(el){
                if(el && !el.hasProductFilter ){
                    el.hasProductFilter = true ;
                    el.addEventListener("change", function(){ rootView.productFiltering() ;}) ;
                }
            }) ;
    
            view.on("render", function(){ rootView.productFiltering() ;}) ;
        }) ;

    }) ;
} ;




module.exports = extension ;